import axios from "axios";

export const loginUser = async (username, password) => {
  const res = await axios.post("/api/login", {
    username,
    password,
  });

  if (!res.data?.token) {
    throw new Error("Login failed: no token received");
  }

  return res.data.token; // ✅ return ONLY token
};
